import { render } from "./CustomerDetailsPage.vue?vue&type=template&id=644b29bd&ts=true"
import script from "./CustomerDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__